(function () {
    'use strict';

    // @ngInject
    function WorkflowsControllerCtor($scope, $injector, _, AnalyticsService, UsersManager, WorkflowManager, AppStates,
                                     OnboardingService, PopupMessageService, ModalService, $state, UiPersistenceService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkflowsController';
        this.AnalyticsService = AnalyticsService;

        this.AnalyticsService.trackPageView(this, 'WorkflowsView');

        this.WorkflowManager = WorkflowManager;
        this.user = UsersManager.getCurrUser();
        this.company = this.user.company;
        this.AppStates = AppStates;
        this.OnboardingService = OnboardingService;
        this.PopupMessageService = PopupMessageService;
        this.ModalService = ModalService;
        this.UiPersistenceService = UiPersistenceService;
        this._ = _;
        this.$state = $state;

        this.projectTypeAssignment = {};
        this.workflowsViewModel = [];
        this.shouldShowWorkflowBanner = false;

        //loaders model
        this.gettingWrokflows = true;
        this.creatingWorkflow = false;
        this.deleteingWorkflow = false;
        this.updateingProjectTypesAssignment = false;
        this.projectTypeToWorkflowMap = null;
        this.WorkflowManager.getWorkflowsForCompany(this.company)
            .then(function success(resp) {
                this.buildViewModel(this.company.workflows);
                this.userhasCreatedWorkflows();
            }.bind(this))
            .catch(function fail(resp) {
            }.bind(this))
            .finally(function finallyHandler() {
                this.gettingWrokflows = false;
            }.bind(this));
    }

    Controllers.WorkflowsController = Class(Controllers.BaseController, {
        constructor: WorkflowsControllerCtor,

        buildViewModel: function buildViewModel(workflows) {
            if (!workflows) {
                this.workflowsViewModel = [];
                return;
            }

            this.workflowsViewModel = angular.copy(workflows);

            this.projectTypeToWorkflowMap = {};
            this.workflowsViewModel.forEach(function workflowIter(workflow) {
                if (workflow.relevant_project_types) {
                    workflow.relevant_project_types.forEach(function projectTypeIter(projectType) {
                        this.projectTypeToWorkflowMap[projectType] = workflow;
                    }.bind(this));
                }
            }.bind(this));
        },

        openWorkflowSetup: function openWorkflowSetup(workflow, $event) {
            var clickWasInsideTheDropDown = angular.element($event.target).closest('.project-type-col__project-types-assignment').length > 0;

            if (clickWasInsideTheDropDown) {
                //dont go into the workflow editing. we this like that instead of calling stopPropagation so that other closing of drop downs will work.
                //(calling stopPropagation will prevent the docuemnt from getting the click event and thus not closing the dropdown list)
                return;
            }

            this.goToState(this.AppStates.root_core_navigation_workflow_setup, {workflow_id: workflow._id});
        },

        onWorkflowNameClicked: function ($event) {
            $event.stopPropagation();
        },

        createNewWorkflow: function createNewWorkflow() {
            this.creatingWorkflow = true;

            this.WorkflowManager.createWorkflow(this.company)
                .then(function success(resp) {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.workflow_created);
                    //find the workflow id that was added
                    var idOfWorkflowThatWasAdded;
                    resp.data.workflows.forEach(function (workflow) {
                        var workflowInViewModel = this._.findWhere(this.workflowsViewModel, {_id: workflow._id});
                        if (!workflowInViewModel) {
                            //found it. (this one is not in the current viewModel, meaning this is the one that was added.
                            idOfWorkflowThatWasAdded = workflow._id;
                        }
                    }.bind(this));
                    this.goToState(this.AppStates.root_core_navigation_workflow_setup, {workflow_id: idOfWorkflowThatWasAdded});
                }.bind(this))
                .catch(function fail(resp) {
                }.bind(this))
                .finally(function finallyHandler() {
                    this.creatingWorkflow = false;
                    this.createdWorkflow();
                }.bind(this));
        },

        deleteWorkflow: function deleteWorkflow(workflow, $event) {
            $event.stopPropagation();

            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'WORKFLOW.ALERTS._DELETE_WORKFLOW_TEMPLATE',
                function clickedYeah() {
                    this.deleteingWorkflow = true;
                    this.WorkflowManager.deleteWorkflow(this.company, workflow._id)
                        .then(function success() {
                            //the response is empty and the company model is updated on the manager
                            this.buildViewModel(this.company.workflows);
                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.workflow_deleted);
                        }.bind(this))
                        .catch(function fail(resp) {
                        }.bind(this))
                        .finally(function finallyHandler() {
                            this.deleteingWorkflow = false;
                        }.bind(this));
                }.bind(this),
                function clickedNay() {
                }.bind(this));
        },

        onSaveWorkflowModal: function onDropDownClosed(workflowModel, projectTypes, defaultForAllProjectTypesSelected) {
            this.updateingProjectTypesAssignment = true;

            //translate the view-model to the model and then update the server
            workflowModel.relevant_project_types = [];
            projectTypes.forEach(function eachIter(projectTypeViewModel) {
                if (projectTypeViewModel.isSelected) {
                    workflowModel.relevant_project_types.push(projectTypeViewModel._id);
                }
            }.bind(this));

            if (defaultForAllProjectTypesSelected) {
                workflowModel.relevant_project_types.push('workflow_project_type_default');
            }

            return this.WorkflowManager.updateWorkflowProjectType(this.company, workflowModel)
                .then(function success(resp) {
                    this.buildViewModel(resp.data.workflows);
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.workflow_update_project_type);
                }.bind(this))
                .catch(function fail(resp) {
                }.bind(this))
                .finally(function finallyHandler() {
                    this.updateingProjectTypesAssignment = false;
                }.bind(this));
        },

        openDuplicateWorkflowModal: function openDuplicateWorkflowModal(workflow, $event) {
            $event.stopPropagation();

            var newTitle = workflow.title + '_New';
            var titleWrapper = { title: newTitle };

            return this.ModalService.openTemplateSaveAsModal(titleWrapper, 'WORKSPACE.WORKFLOW.LABELS._DUPLICATE_WORKFLOW_LABEL_', false,
                function success() {
                    return this.WorkflowManager.duplicateWorkflow(this.company, workflow, titleWrapper.title).then(function success() {
                        this.buildViewModel(this.company.workflows);
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.workflow_duplicated);
                        this.createdWorkflow();
                    }.bind(this));
                }.bind(this));
        },
        navigateToContactForm: function navigateToContactForm(){
            this.$state.go(this.AppStates.root_core_navigation_templatesEditor, {templateModelKey: 'contactForm'});
        },

        createdWorkflow: function createdWorkflow(){
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.createdWorkflow, {createdNew: true});
        },

        hadCreatedworkflows: function(){
            var createdWorkflowHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.createdWorkflow) || {};
            return createdWorkflowHash.createdNew ? createdWorkflowHash.createdNew : false;
        },

        userhasCreatedWorkflows: function userhasCreatedWorkflows() {
            if (this.hadCreatedworkflows()){
                return;
            }

            var customWorks = this._.filter(this.company.workflows, function (workflow) {
                return workflow.title.indexOf('HB TEMPLATE') === -1;
            });

            this.shouldShowWorkflowBanner = !customWorks.length;
        }

    });
}());
